/* eslint-disable linebreak-style */
import React from 'react';

const UserAgentContext = React.createContext(null);

export default UserAgentContext;
